export enum ROUTE {
  DASHBOARD = '/',
  LOGIN = '/login',
  SET_PASSWORD = '/set-password',
  FORGOT_PASSWORD = '/forgot-password',
  FORMS = '/forms',
  FORM = '/form',
  SETTINGS = '/settings',
  CUSTOMERS = '/customers',
  USERS = '/users',
  STUDIOS = '/studios',
  REQUEST = '/request',
  REQUESTS = '/requests',
  PATIENTS = '/patients',
  DEMOS = '/demos',
  PROFILE = '/profile',
  BILLING = '/billing',
  DOCTORS = '/doctors',
  FAILED_SHOPIFY_ORDERS = '/failed-shopify-orders',
  PRESIGN_REQUESTS = '/presign-requests',
  // IMPRINT = '/imprint',
  // PRIVACY = '/privacy',
  CALENDAR = '/calendar',
  EXPORT_LOGS = '/export-logs',
}
